import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SiteService } from '../site/site.service';
import { UserManagementService } from '../user-management/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NotificationsService } from '../notifications/notifications.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
@Component({
    selector: 'app-site-admin-nav',
    templateUrl: './site-admin-nav.component.html',
    styleUrls: ['./site-admin-nav.component.css'],
    standalone: false
})
export class SiteAdminNavComponent implements OnInit, OnDestroy {
  private storage = environment.storage;
  @ViewChild('content') content;
  @ViewChild('picker') picker: any;
  @ViewChild('notificationListComponent') notificationListComponent: any;
  @ViewChild('siteEditStatusDialog') siteEditStatusDialog: any;
  public dateRange: any;
  public isCollapsed = false;
  public isMenuCollapsed = true;
  public user: any;
  allocatedSite:any;
  public siteinfo:any;
  pdfurl:any;
  sitename:any;
  periodicDateRange : any;
  modelref : any;
  data: any;
  loading = 0;
  visitedUserManagementSites = false;
  unreadNotificationCount = 0;
  isNotificationPanelOpen = false;
  private subscriptions: Subscription[] = [];
  avatarUrl: string = './assets/images/avathar.jpg';
  imageSrc: SafeUrl | string = this.avatarUrl;
  constructor( 
    private router: Router,
    private userService: UserManagementService,
    private siteService: SiteService,
    private modalService: NgbModal,
    private notificationService: NotificationsService,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const allSites = this.userService.getSiteDetail();
    this.user = this.userService.getUserDetail();
    this.siteinfo=this.userService.getSiteDetail();
    if(allSites?.length){
      this.allocatedSite = allSites[0].site_id;
      this.pdfurl = this.siteService.getPDFUrl(this.siteinfo[0].sitepfd);
      this.sitename=this.siteinfo[0].site_name;
    }
    if (this.user?.id || this.user?.user_id) {
      this.loadUserImage(this.user.id || this.user.user_id);
    } else {
      this.imageSrc = this.avatarUrl;
    }
     this.visitedUserManagementSites = sessionStorage.getItem('visitedUserManagementSites') === 'true';
     
     // Subscribe to notification unread count
     const unreadSub = this.notificationService.unreadCount$.subscribe(
       (count) => {
         this.unreadNotificationCount = count;
         // Trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
         this.cdr.detectChanges();
       }
     );
     this.subscriptions.push(unreadSub);
  }

  loadUserImage(userId: string | number): void {
    if (!userId) {
      this.imageSrc = this.avatarUrl;
      return;
    }
    const imageUrl = `${environment.nodeUrl1}user-image/${userId}?t=${Date.now()}`;
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe(
      (blob) => {
        this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob)
        );
      },
      () => {
        this.imageSrc = this.avatarUrl;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  logout() {
    // Clear filter selections before logout
    this.clearAllFilterSelections();
    
    this.userService.logout();
    sessionStorage.removeItem('visitedUserManagementSites');
    sessionStorage.removeItem('admin_id');
  }

  private clearAllFilterSelections(): void {
    try {
      const allKeys = Object.keys(localStorage);
      const filterKeys = allKeys.filter(key => key.startsWith('reportFilter_'));
      
      filterKeys.forEach(key => {
        localStorage.removeItem(key);
        console.log(`✅ Site Admin Nav: Cleared filter selection for key: ${key}`);
      });
      
      console.log(`🎉 Site Admin Nav: Cleared ${filterKeys.length} filter selections`);
    } catch (e) {
      console.error('❌ Error clearing filter selections in site-admin-nav:', e);
    }
  }

  onPlantCustomizationClick() {
    console.log('=== PLANT CUSTOMIZATION CLICKED ===');
    console.log('Timestamp:', new Date().toISOString());
    console.log('User Role:', this.user?.role);
    console.log('Site ID:', this.allocatedSite);
    console.log('Site Name:', this.sitename);
    console.log('Navigation URL:', `/site/editsite/${this.allocatedSite}`);
    console.log('================================');

    // Get user_id from user object
    const userId = this.user?.id || this.user?.user_id || null;
    const siteId = this.allocatedSite;

    // Make API call to check site edit status
    if (siteId && userId) {
      const payload = {
        site_id: siteId,
        user_id: userId,
        site_edit_status: true
      };

      this.http
        .post(`${environment.nodeUrl1}site/updateEditCheck`, payload)
        .toPromise()
        .then((response: any) => {
          console.log('Site edit status response:', response);
          
          // Check if response has data and site_edit_status
          if (response && response.data && response.data.site_edit_status !== undefined) {
            const siteEditStatus = response.data.site_edit_status;
            
            if (siteEditStatus === 0) {
              // Navigate to site-setting
              this.router.navigate(['/site-setting']);
            } else if (siteEditStatus === 1) {
              // Open dialog box with blurred backdrop
              this.modalService.open(this.siteEditStatusDialog, {
                centered: true,
                backdrop: 'static',
                keyboard: false,
                backdropClass: 'site-edit-status-backdrop',
                windowClass: 'site-edit-status-modal-window'
              });
            }
          } else {
            console.warn('Invalid response structure:', response);
          }
        })
        .catch((error) => {
          console.error('Error checking site edit status:', error);
        });
    } else {
      console.warn('Cannot check site edit status: missing site_id or user_id', {
        siteId,
        userId
      });
    }
  }

  navigateToHome(modal: any): void {
    modal.close();
    this.router.navigate(['/']);
  }

  toggleNotificationPanel(): void {
    this.isNotificationPanelOpen = !this.isNotificationPanelOpen;
    // Prevent body scroll when panel is open
    if (this.isNotificationPanelOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeNotificationPanel(): void {
    this.isNotificationPanelOpen = false;
    document.body.style.overflow = '';
  }

  onBackdropClick(event: MouseEvent): void {
    // Close panel when clicking on backdrop
    if ((event.target as HTMLElement).classList.contains('notification-backdrop')) {
      this.closeNotificationPanel();
    }
  }

  onDmsClick(): void {
    // Navigate to DMS user setting page first for OTP authentication
    // Store the target DMS URL in sessionStorage to redirect after OTP verification
    sessionStorage.setItem('dmsRedirectUrl', '/site/dms');
    this.router.navigate(['/site/dms-user-setting']);
  }

  onDmsUserSettingClick(): void {
    // Clear any existing DMS redirect URL to show original content
    sessionStorage.removeItem('dmsRedirectUrl');
    this.router.navigate(['/site/dms-user-setting']);
  }

}
